import {
	COMPONENT_STATES,
	COMPONENT_TYPE as TYPE,
	DEFAULT_MEDIA_QUERY_PLATFORMS,
	UNIFORM_PROPS,
} from 'common/constants';
import { getText } from 'common/utils/dictionary';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Fields/Checkbox/Checkbox';
import { FIELD_BB_ERROR_TYPE, FIELD_BB_STYLE } from '../constants';

/**
 * @param options {Object=}
 * @param options.dictionary {Object=}
 * @returns {{ view, model }}
 * @constructor
 */
export const CHECKBOX = (options = { dictionary: {} }) => {
	const _id = generateElementId();

	return {
		view: View,
		get model() {
			const type = TYPE.CHECKBOX;

			return {
				_id,
				type,
				uiConfig: {
					layer: undefined,
					editorProps: {
						name: CHECKBOX.displayName,
						selectable: true,
						draggable: true,
						expandable: false,
						expanded: false,
						[UNIFORM_PROPS.fieldErrorShow]: FIELD_BB_ERROR_TYPE.required,
					},

					componentProps: {
						styles: {
							[COMPONENT_STATES.DEFAULT]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[FIELD_BB_STYLE.BOX.STROKE]: 'rgba(204, 204, 204, 1)',
									[FIELD_BB_STYLE.BOX.FILL]: 'rgba(255, 255, 255, 1)',
								},
							},
							[COMPONENT_STATES.HOVER]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[FIELD_BB_STYLE.BOX.STROKE]: 'rgba(77, 156, 255, 1)',
									[FIELD_BB_STYLE.BOX.FILL]: 'rgba(255, 255, 255, 1)',
								},
							},
							[COMPONENT_STATES.SELECTED]: {
								[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
									[FIELD_BB_STYLE.BOX.STROKE]: 'rgba(77, 156, 255, 1)',
									[FIELD_BB_STYLE.BOX.FILL]: 'rgba(77, 156, 255, 1)',
									[FIELD_BB_STYLE.BOX.ICON_COLOR]: 'rgba(255, 255, 255, 1)',
								},
							},
						},
						other: {},
					},
					nodeProps: {
						id: generateNodeId(_id, CHECKBOX.displayName),
					},
				},
				children: {
					[COMPONENT_STATES.DEFAULT]: {
						[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: getText(options.dictionary, type, 'text'),
					},
				},
			};
		},
	};
};

CHECKBOX.displayName = 'Checkbox';
